
import {
  getSubmitStagePage,
  getStageType,
} from "@/api/performance";


export default {

  data() {
    return {
      firstIndicatorPhase: {
        groupUuid: '', stageUuid: '', stageName: '',
      },
      stageType: 0,
      submit: 0,
      theEnd: 0,
      isVisibleInHome: false,
    }
  },

  computed: {
    linkPath() {
      const { groupUuid, stageUuid, stageName } = this.firstIndicatorPhase;
      // theEnd 1 过期 submit
      // 1 0  // 未提交
      // 1 1 // uploadStatus
      // 0 1 // uploadStatus
      // 0 0 // uploadHome
      if (!!Number(this.submit)) {
        return `/performance/uploadStatus?groupUuid=${groupUuid}&stageUuid=${stageUuid}&stageName=${stageName}`; //&targetName=${stageName}
      } else {
        if (!!Number(this.theEnd)) {
          return `/performance/uploadStatusOutTime?groupUuid=${groupUuid}&stageUuid=${stageUuid}&stageName=${stageName}`; //&targetName=${stageName}
        } else {
          return `/performance/uploadHome?groupUuid=${groupUuid}&stageUuid=${stageUuid}&stageName=${stageName}&stageType=${this.stageType}`;  // &targetName=${stageName}
        }
      }
      // if (!!Number(this.submit)) {
      //   // if(!!Number(1)) { // debugger
      //   return `/performance/uploadStatus?groupUuid=${groupUuid}&stageUuid=${stageUuid}&stageName=${stageName}`; //&targetName=${stageName}

      // } else {
      //   return `/performance/uploadHome?groupUuid=${groupUuid}&stageUuid=${stageUuid}&stageName=${stageName}&stageType=${this.stageType}`;  // &targetName=${stageName}
      // }

    }
  },

  mounted() {
    this.loadIndicatorPhaseComFirstDataOfList()
  },


  methods: {

    // loadIndicatorPhaseComFirstDataOfList() {
    //   const defaultParams = {
    //     page: 0,
    //     size: 1,  // 默认情况下应该只有一条数据
    //   }
    //   this.isVisibleInHome = false;
    //   getSubmitStagePage(defaultParams)
    //     .then(async res => {
    //       if (res.code) {
    //         this.$message.error(res.msg);
    //         return;
    //       }
    //       this.firstIndicatorPhase = res.content[0] || {}
    //       if(res.content.length) {
    //         try {
    //           const paramsData = {
    //             stageUuid: res.content[0].uuid
    //           }
    //           const { stageType, submit } =  await getStageType(paramsData);
    //           this.isVisibleInHome = true;
    //           if(stageType) this.stageType = stageType;
    //           if(submit) this.submit = submit;
    //         } catch(err) {
    //           this.isVisibleInHome = false;
    //           console.error('err', err)
    //         }
    //       } else {
    //         this.isVisibleInHome = true;
    //         this.stageType = 1;
    //       }
    //     })
    //     .catch((err) => {
    //       console.error("err", err);
    //     });
    // },


    async loadIndicatorPhaseComFirstDataOfList() {
      try {
        const data = await getStageType({});
        if (!data) {
          this.isVisibleInHome = true;
          this.stageType = 1;
          this.firstIndicatorPhase = { groupUuid: '', stageUuid: '', stageName: '', };
        } else {
          const { stageType, theEnd, submit, ...other } = data;
          this.isVisibleInHome = true;
          if (stageType) this.stageType = stageType;
          if (submit) this.submit = submit;
          if (theEnd) this.theEnd = theEnd;
          this.firstIndicatorPhase = other;
        }

      } catch (err) {
        this.isVisibleInHome = false;
        console.error('err', err)
      }
    },

    handleHomeJump() {
      const { groupUuid, stageUuid, stageName } = this.firstIndicatorPhase;
      this.$router.push({
        path: "upload",
        query: {
          groupUuid: groupUuid,
          stageName: stageName,
          stageUuid: stageUuid,
        },
      });
    },
  },
}
